import React, { useState } from "react";
import image from "../assets/img/logotipo.svg";
import menuIcon from "../assets/img/new-menu-fill.svg";
import ContactOptions from "./ContactOptions";
import "../assets/css/Navbar.css";


const Navbar = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const navItems = [
    { text: "Sobre nós", href: "#about" },
    { text: "Produtos", href: "#products-container" },
    { text: "Nossa História", href: "#history-container" },
    { text: "Depoimentos", href: "#testimonials" },
  ];

  return (
    <header className="bg-nav">
      <nav className="navbar navbar-expand-md navbar-light mx-lg-3">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <a className="navbar-brand mx-auto" href="/">
            <img
              src={image}
              className="img-fluid logo-nav"
              alt="Logo Gao Technologia"
            />
          </a>
          <div
            className="custom-toggler"
            onClick={() => {
              const navbarNav = document.getElementById("navbarNav");
              navbarNav.classList.toggle("show");
            }}
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <img src={menuIcon} className="menu-fill" alt="Menu" />
          </div>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="custom-nav navbar-nav ms-auto">
              {navItems.map((item, index) => (
                <li className="nav-item" key={index}>
                  <a className="nav-link link-custom" href={item.href} target={item.target || "_self"}>
                    {item.text}
                  </a>
                </li>
              ))}
            </ul>
            <a className="" href="https://gaotech.com.br/suporte/auth" target="_blank" rel="noopener noreferrer">
              <button className="btn-custom_border">ÁREA DO CLIENTE</button>
            </a>
            <button className="btn-custom" onClick={handleShow}>Entre em contato</button>
          </div>
        </div>
        <ContactOptions show={showModal} handleClose={handleClose} />
      </nav>
    </header>
  );
};

export default Navbar;